import React from 'react';
import Chart from 'react-apexcharts';
import formatConditional from './formatConditional';
export default function HorizontalBarChart(_ref) {
  let {
    data,
    dataName,
    formatTooltip = false
  } = _ref;
  const currencyFormatter = window.MARKET_CONSTANTS.CURRENCY_FORMATTER;
  const seriesData = data.map(singleBarData => ({
    ...singleBarData,
    x: singleBarData.label,
    y: singleBarData.value
  }));
  const series = [{
    name: dataName,
    data: seriesData
  }];
  const conditionalFormat = value => formatConditional(value, formatTooltip, currencyFormatter);
  const options = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true
      }
    },
    tooltip: {
      y: {
        formatter: conditionalFormat
      }
    },
    dataLabels: {
      enabledOnSeries: [0],
      style: {
        colors: ['#00aeef'],
        fontFamily: 'Franklin Gothic Book, sans-serif',
        fontSize: '16px'
      },
      formatter: conditionalFormat
    },
    xaxis: {
      labels: {
        style: {
          colors: '#666E7E',
          fontSize: '12px',
          fontWeight: 'bold',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        },
        formatter: conditionalFormat
      }
    },
    yaxis: {
      type: 'category',
      labels: {
        style: {
          colors: '#666E7E',
          fontSize: '14px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: series,
    type: "bar",
    height: "290px"
  }));
}